export const CHANGELOG_SET_SEEN_IDS = 'CHANGELOG_SET_SEEN_IDS';
export const CHANGELOG_ADD_SEEN_IDS = 'CHANGELOG_ADD_SEEN_IDS';
